export default __webpack_public_path__ + "svelte.38600239.png";